const tutorialSettingEnum = {
  saba: {
    count: 5,
  },
};
export default tutorialSettingEnum;
